import { memo, useState, useMemo, useEffect, useCallback } from 'react';
import Popover from 'react-bootstrap/Popover';
import { BzPopoverOverlay, BzChip } from "../../../components";
import { Col, Row } from 'react-bootstrap';
import { ALL_ORDERS_STATUS, TL_INDEX, WATCHLIST_GRID_INDEX, FACILITY_NUM, ORDER_TYPES } from '../../../utils/global_variables';
import {
    ORDERS_GRID_REF, getMktSegIdFromApiExchangeName, getArrSipScripOrderInfo,
    getDecimalLocatorFromApiExchangeName, getDynamicParamsForToFixed, ORDER_ENTRY_GRID_REF,
    convertScripResponseWatchlistGrid
} from '../../../utils/global_functions';
import { useLeftClick } from '../../../hooks';
import { sendBestFiveRequest } from '../../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getOrderInfo, getScripOrderInfo } from '../../../redux/actions/orders';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { DontMissChip } from '../..';
import { getScripbyTokenAndMktSegId } from '../../../apis';
import { _getScripsInfo } from '../../../controllers';
import { setScripOverviewData } from '../../../redux/actions/marketOverview';


let segmentId;
const SipGridPopover = (props) => {
    const dispatch = useDispatch();
    const { data, children,
        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        placement = 'right'
        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    } = props;
    const sipData = ORDERS_GRID_REF?.current?.props?.rowData?.filter(ele => ele?.id === data?.id)?.[0] ?? data;
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing 
    const [showPopover, setShowPopover] = useState(false);
    const { holdingsScrips } = useSelector(state => state.holdings);
    //ManasaB : 13-06-2024 : Changed to left click in grid : Start
    const leftClick = (e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    };

    const [targetElement] = useLeftClick(leftClick);
    //ManasaB : 13-06-2024 : Changed to left click in grid : End
    const onContextMenu = (e) => {
        if (e?.ctrlKey) {
            return;
        }
        e.preventDefault();
        setShowPopover(true);
    };

    let location = useLocation();


    useEffect(() => {
        if (location?.state?.length > 0) {
            const nIndex = ORDERS_GRID_REF?.current?.api?.getRowNode(location?.state)?.rowIndex;
            ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex)?.setSelected(true, true);
            ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex)?.setExpanded(true);
            setShowPopover(false);
        } else {

        }

    }, [location.state]);


    const handleOrderHistory = () => {
        const nIndex = ORDERS_GRID_REF?.current?.api?.getRowNode(data?.id).rowIndex;
        ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(nIndex).setExpanded(true);
        setShowPopover(false);
    };

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    segmentId = getMktSegIdFromApiExchangeName(data?.exchangeSegment);
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    const arrRowData = useMemo(() => ORDERS_GRID_REF?.current?.api?.getRowNode(data?.id)?.data, [data]);

    // scrip live details in overlay - start
    const [arrScripData, setArrScripData] = useState([]);
   

    useEffect(() => {
        if (arrRowData?.scrip_token) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[segmentId + '_' + arrRowData?.scrip_token];
            if (arrLastTickScripData?.length > 0) {
                setArrScripData([...arrLastTickScripData]);
                // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
            } else {
                const arrData = Array(Object.keys(TL_INDEX)?.length)?.fill('0.00');
                arrData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = parseFloat(0)?.toFixed(getDynamicParamsForToFixed(data?.exchangeSegment));
                arrData[TL_INDEX.LAST_TRADE_PRICE] = parseFloat(0)?.toFixed(getDynamicParamsForToFixed(data?.exchangeSegment));
                arrData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = '0.00';
                setArrScripData(arrData);
            }
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

        } else { }
    }, [dispatch, arrRowData]);

    const getHoldingsData = useCallback(() => {
        let nIndex = holdingsScrips?.findIndex((eachHolding) => eachHolding?.nMarketSegmentId + '_' + eachHolding?.nToken === segmentId + '_' + arrRowData?.scrip_token);
        return nIndex;
    }, [holdingsScrips, arrRowData]);

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleModifyOrder = async () => {
        setShowPopover(false);
        const arrScrips = [{ mkt: data?.exchangeSegment, token: data?.scrip_token }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, capPrice: data?.cap_price, quantity: data?.invested_qty_or_val, numberOfInstallment: data?.no_of_installments, scripLot: data?.totalQuantity / data?.market_lot, startDate: data?.created_date }));
        // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */ }
        ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, frequency: data?.frequency_type, day_date: data?.frequency_monthly_option }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
        // {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
        const scripOrderInfoPayload = {
            isBuySell, activeExchangeId: gridFormatData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: gridFormatData[0],
            isModifyOrder: true, data
        };
        dispatch(getScripOrderInfo(scripOrderInfoPayload));
        // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
        dispatch(handleModalData({ orderData: data, scripOrderInfo: [], orderType: ORDER_TYPES.EQUITY_SIP, data: { orderEntryTab: ORDER_TYPES.EQUITY_SIP } }));
        // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }
        // {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }
    };

    const handleReorder = async () => {
        setShowPopover(false);
        const arrScrips = [{ mkt: data?.exchangeSegment, token: data?.scrip_token }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, capPrice: data?.cap_price, quantity: data?.invested_qty_or_val, numberOfInstallment: data?.no_of_installments, scripLot: data?.totalQuantity / data?.market_lot }));
        ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, frequency: data?.frequency_type, day_date: data?.frequency_monthly_option }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
        // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- Start  
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.EQUITY_SIP } }));
        // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- End
        dispatch(getScripOrderInfo({
            isBuySell, activeExchangeId: gridFormatData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: gridFormatData[0],
            isReOrder: true
        }));
    };
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End



    const handleCancelOrder = useCallback(() => {

        const scripData = getArrSipScripOrderInfo(data);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        dispatch(getOrderInfo(data));
        dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData }));
        setShowPopover(false);
        dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': true }], true));

    }, [data, dispatch]);
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleSetAlert = () => {
        setShowPopover(false);
        dispatch(handleModalData({
            AlertData: {
                symbol: data?.symbol,
                exchange: data?.exchange,
                series: data?.series,
                description: data?.series,
                token: data?.scrip_token,
                mktId: data?.segment_id?.split('_')[0],
                decimalLocator: getDecimalLocatorFromApiExchangeName(data?.exchangeSegment),
                decimalLocator_length: getDynamicParamsForToFixed(data?.exchangeSegment),
                exchange_segement: data?.exchangeSegment
            },
            isShowAlerts: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };

    const handleOverview = async () => {
        setShowPopover(false);
        //Vaibhav Singh: BT-109089: 26-10-2023: Called Apis for Row Data for scripOverview from Netposiitons
        // const arrRowData = getArrSingleScripOrderInfo(objRowData);
        const scripDataRes = await _getScripsInfo([{ mkt: data?.exchangeSegment, token: data?.scrip_token }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        sendBestFiveRequest({ exchangeId: scripData?.[0]?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripData?.[0]?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
        dispatch(setScripOverviewData(scripData?.[0]));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
    };
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

    // Vinit R : 17-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- Start
    const handleSipOrderStatus = (status) => {
        setShowPopover(false);
        dispatch(handleModal([{ 'SIP_ORDER_STATUS_MODAL': true }], true));
        dispatch(handleModalData({ orderData: sipData, sipOrderStatus: status }));
    };
    // Vinit R : 17-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- End
    const BzPopover = (
        <Popover className='scripdetails-popover'>
            <Popover.Header>
                <div className='p-2'>
                    <Row className='g-0'>
                        <Col md={8}>
                            <Row className='g-0'>
                                <Col className='d-flex align-items-center'>
                                    <div className='font-medium font-size4 color-text me-2'>{data?.symbol}</div>
                                    <div className='chips-wrap'>
                                        <BzChip className='exchange-chip'>{data?.exchange}</BzChip>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='font-regular font-size4 color-subtext'>{data?.series}</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <Row className='g-0'>
                                <Col className='flex-column text-end'>
                                    <div className='font-medium font-size4 color-text'>{arrScripData?.[TL_INDEX.LAST_TRADE_PRICE]}</div>
                                    <div className={`font-regular font-size2 color-text color-positive  ${arrScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] >= 0 ? 'color-positive' : 'color-negative'}`}>{arrScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]}  ({arrScripData?.[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE]} %)</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Popover.Header>

            <Popover.Body className='d-flex flex-column'>
                {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- Start */}
                <div className='bdr-top bdr-btm'>
                    {sipData && sipData?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_RUNNING &&
                        <Row className='g-0 py-2 popover-menu' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_RUNNING)}>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-pause icon-dark'></div>
                                <div className='font-regular font-size4 color-text ms-2'>Pause order</div>
                            </Col>
                        </Row>
                    }
                    {sipData && sipData?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_STOPPED &&
                        <Row className='g-0 py-2 popover-menu' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_STOPPED)}>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-play icon-dark'></div>
                                <div className='font-regular font-size4 color-text ms-2'>Resume order</div>
                            </Col>
                        </Row>
                    }

                    {sipData && (sipData?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_RUNNING || sipData?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_STOPPED) &&
                        <Row className='g-0 py-2 popover-menu' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_DEACTIVATED)}>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-stop icon-dark'></div>
                                <div className='font-regular font-size4 color-text ms-2'>Stop order</div>
                            </Col>
                        </Row>
                    }
                    {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- End */}

                    {sipData && sipData?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_PENDING &&
                        <>
                            <Row className='g-0 py-2 popover-menu' onClick={handleModifyOrder}>
                                <Col className='d-flex align-items-center'>
                                    <div className='icon-16 icon-edit icon-dark'></div>
                                    <div className='font-regular font-size4 color-text ms-2'>Modify order</div>
                                </Col>
                            </Row>
                            <Row className='g-0 py-2 popover-menu' onClick={handleCancelOrder}>
                                <Col className='d-flex align-items-center'>
                                    <div className='icon-16 icon-close icon-dark'></div>
                                    <div className='font-regular font-size4 color-text ms-2'>Cancel order</div>
                                </Col>
                            </Row>
                        </>
                    }
                    {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                    {sipData && sipData?.status === ALL_ORDERS_STATUS?.ORDER_STATUS_COMPLETED &&
                        <Row className='g-0 py-2 popover-menu' onClick={handleReorder}>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-convert icon-dark'></div>
                                <div className='font-regular font-size4 color-text ms-2'>Reorder</div>
                            </Col>
                        </Row>}
                    {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                    <Row className='g-0 py-2 popover-menu' onClick={handleOrderHistory}>
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-convert icon-dark'></div>
                            <div className='font-regular font-size4 color-text ms-2'>Order History</div>
                        </Col>
                    </Row>
                    {/* Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                    <Row className='g-0 py-2 popover-menu' onClick={handleOverview}>
                        {/* Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                        <Col className='d-flex align-items-center'>
                            <div className='icon-16 icon-dark icon-overview'></div>
                            <div className='font-regular font-size3 color-text ms-2'>Overview</div>
                        </Col>
                    </Row>
                    {/* Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                    <Row className='g-0 py-2 popover-menu' onClick={handleSetAlert}>
                        {/* Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                        <Col className='d-flex align-items-center'>
                            {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing --start  */}
                            {objCFT.ALERT === FACILITY_NUM.ON ? (<> <div className='icon-16 icon-dark icon-bell'></div>
                                <div className='font-regular font-size3 color-text ms-2'>Set Alert</div></>) : null}
                        </Col>
                        {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing --end  */}

                    </Row>

                </div>
                <div className='px-2 pb-2'>
                    <Row className='g-0 py-2 cursor-pointer'>
                        <Col className='d-flex align-items-center'>
                            {getHoldingsData() >= 0 && <div className='icon-16 icon-portfolio icon-dark'></div>}
                            {getHoldingsData() >= 0 && <div className='font-regular font-size3 color-text ms-2'>{holdingsScrips[getHoldingsData()].TOTALFREEQUANTITY}</div>}
                            {getHoldingsData() >= 0 && <div className={`font-regular font-size3 color-text ms-2
                                    ${arrScripData?.[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE]?.toString()?.split('')[0] === '-' ? 'color-negative' : 'color-positive'}
                                    `}>{arrScripData?.[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE]}%</div>}
                        </Col>
                    </Row>
                    {
                        arrRowData?.dontMiss !== '0' && arrRowData?.dontMiss?.length > 0 &&
                        <Row className='g-0 py-2'>
                            <Col className='d-flex align-items-center'>
                                <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                <div className='chips-wrap ms-2'>
                                    <DontMissChip value={arrRowData?.dontMiss} />
                                </div>
                            </Col>
                        </Row>
                    }
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
            <BzPopoverOverlay rootClose trigger='click' show={showPopover} onToggle={() => setShowPopover(false)} placement={placement} popover={BzPopover}>
                {/* ManasaB : 13-06-2024 : Changed to left click in grid : Start */}
                <div className='scrip-wrap text-center' ref={targetElement} onClick={onContextMenu}>
                    {children}
                </div >
                {/* ManasaB : 13-06-2024 : Changed to left click in grid : End */}
            </BzPopoverOverlay >
            {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}

        </>
    );
};

export default memo(SipGridPopover);